import { ContentEmpty } from 'components/ContentLayout'
import * as React from 'react'
import { observer } from 'mobx-react'
import ProfilePayoutMethodViewModel from './ProfilePayoutMethodViewModel'
import PayoutMethodsEmptyState from 'billing/components/PayoutMethodsEmptyState'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import Icon from 'components/Icon'
import { ContentLabel } from 'components/ContentLabel'
import {
  BillingItem,
  BillingItemContent,
  BillingItemExtras,
  BillingItemSubtitle,
  BillingItemTitle,
  BillingItemVisual,
} from 'billing/components/BillingItemList'
import { PayoutMethod } from 'payouts/pro/PayoutMethod'
import IconVisual from 'components/IconVisual'
import Button from 'components/Button'

interface PayoutMethodProps {
  vm: ProfilePayoutMethodViewModel
}

export default observer(function PayoutMethod({ vm }: PayoutMethodProps) {
  return (
    <>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => (
          <>
            {!vm.payoutMethod ? (
              <ContentEmpty>
                <PayoutMethodsEmptyState
                  canAddPayoutMethod={true}
                  onNewPayoutMethod={vm.addPayoutMethod}
                />
              </ContentEmpty>
            ) : (
              <>
                <ContentLabel>Payout Method</ContentLabel>
                <BillingItem>
                  <PayoutMethodType payoutMethod={vm.payoutMethod} />

                  <BillingItemExtras>
                    <Button type="default" onClick={vm.addPayoutMethod}>
                      Replace
                    </Button>
                  </BillingItemExtras>
                </BillingItem>
              </>
            )}
          </>
        ),
      })}
    </>
  )
})

interface PayoutMethodTypeProps {
  payoutMethod: PayoutMethod
}

const PayoutMethodType = observer(function PayoutMethodType({
  payoutMethod,
}: PayoutMethodTypeProps) {
  switch (payoutMethod.type) {
    case 'Stripe': {
      return (
        <>
          <BillingItemVisual>
            <Icon color="#6772E5" size={48} name="stripe-logo" />
          </BillingItemVisual>

          <BillingItemContent>
            <BillingItemTitle data-test="payout-method-title">
              via Stripe
            </BillingItemTitle>
            <BillingItemSubtitle data-test="payout-method-subtitle">
              {payoutMethod.stripeAccountId}
            </BillingItemSubtitle>
          </BillingItemContent>
        </>
      )
    }
    default: {
      return (
        <>
          <BillingItemVisual>
            <IconVisual>
              <Icon name="info" />
            </IconVisual>
          </BillingItemVisual>
          <BillingItemContent>
            <BillingItemTitle data-test="payout-method-title">
              Unknown Payout Method "{payoutMethod.type}"
            </BillingItemTitle>
            <BillingItemSubtitle>
              This version of the app does not recognize this payout type.
            </BillingItemSubtitle>
          </BillingItemContent>
        </>
      )
    }
  }
})
